import { render, staticRenderFns } from "./TimelineEdit.vue?vue&type=template&id=5179e5ee&scoped=true&"
import script from "./TimelineEdit.vue?vue&type=script&setup=true&lang=js&"
export * from "./TimelineEdit.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5179e5ee",
  null
  
)

export default component.exports